export enum WidgetResultState {
  SHOWN = 'shown',
  HIDDEN = 'hidden',
}
export enum WidgetUIPhase {
  INTERACTIVE = 'interactive',
  SUBMITTING = 'submitting',
  SUBMITTED = 'submitted',
  INTERACTIVE_TIMED_OUT = 'interactive-timed-out',
  EXPIRED = 'expired',
  FOLLOW_UP_PUBLISHED = 'follow-up-published',
}

export enum WidgetMode {
  POPUP = 'popup',
  INTERACTIVE_TIMELINE = 'interactive-timeline',
}
